import { Stack } from "expo-router";
import { Platform } from "react-native";
import { useTheme } from "~/providers/ThemeProvider";

export default function ShareLayout() {
    const { dark } = useTheme();

    return (
        <Stack
            screenOptions={{
                headerTransparent: true,
                title: "",
                statusBarStyle: Platform.select({ android: dark ? "light" : "dark", default: undefined }),
            }}
        />
    );
}
